import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { Col, Form, Row } from "react-bootstrap";
import { formatDate } from "../../../constants/helper";

const RstHistoryCard = ({ jual }) => {
  const rst1ArchiveSuffix = jual?.isRst2 ? "3" : "2";

  const histories = [
    {
      isVisible: jual?.isRst1,
      title: "RST 1",
      tglRst: jual?.tglRst1,
      tenor: jual?.[`tenor${rst1ArchiveSuffix}`],
      sisaBulan: jual?.[`sisaBulan${rst1ArchiveSuffix}`],
      angPerBulan: jual?.[`angPerBulan${rst1ArchiveSuffix}`],
      angModal: jual?.[`angModal${rst1ArchiveSuffix}`],
      angBunga: jual?.[`angBunga${rst1ArchiveSuffix}`],
    },
    {
      isVisible: jual?.isRst2,
      title: "RST 2",
      tglRst: jual?.tglRst2,
      tenor: jual?.tenor2,
      sisaBulan: jual?.sisaBulan2,
      angPerBulan: jual?.angPerBulan2,
      angModal: jual?.angModal2,
      angBunga: jual?.angBunga2,
    },
  ].filter((history) => history.isVisible);

  if (histories.length === 0) {
    return null;
  }

  return (
    <Box sx={rstHistoryContainer}>
      <Typography variant="h6" sx={rstHistoryTitle}>
        Riwayat RST
      </Typography>
      {histories.map((history, index) => (
        <Box
          key={history.title}
          sx={index === 0 ? rstHistorySection : rstHistorySectionWithSpacing}
        >
          <Typography variant="subtitle1" sx={rstHistorySubtitle}>
            {history.title}
          </Typography>
          <RstHistoryRow label="Tanda RST" value={`RST/${formatDate(history.tglRst)}`} />
          <RstHistoryRow label="Tenor Lama" value={formatPlainNumber(history.tenor)} />
          <RstHistoryRow
            label="Sisa Bulan Lama"
            value={formatPlainNumber(history.sisaBulan)}
          />
          <RstHistoryRow
            label="Ang/Bln Lama"
            value={formatCurrencyNumber(history.angPerBulan)}
          />
          <RstHistoryRow
            label="Ang Modal Lama"
            value={formatCurrencyNumber(history.angModal)}
          />
          <RstHistoryRow
            label="Ang Bunga Lama"
            value={formatCurrencyNumber(history.angBunga)}
          />
          {index < histories.length - 1 && <Divider sx={{ mt: 2 }} />}
        </Box>
      ))}
    </Box>
  );
};

const RstHistoryRow = ({ label, value }) => (
  <Row>
    <Col>
      <Form.Group as={Row} className="mb-2">
        <Form.Label column sm="4" style={textRight}>
          {label} :
        </Form.Label>
        <Col sm="8">
          <Form.Control value={value} disabled />
        </Col>
      </Form.Group>
    </Col>
  </Row>
);

const formatPlainNumber = (value) => Number(value || 0).toLocaleString("en-US");

const formatCurrencyNumber = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    maximumFractionDigits: 2,
  });

const textRight = {
  textAlign: "end",
};

const rstHistoryContainer = {
  border: "1px solid #d0d7de",
  borderRadius: 1,
  p: 2,
  mt: 2,
  backgroundColor: "#fafafa",
};

const rstHistoryTitle = {
  fontWeight: "700",
  mb: 1.5,
};

const rstHistorySection = {
  width: "100%",
};

const rstHistorySectionWithSpacing = {
  width: "100%",
  mt: 2,
};

const rstHistorySubtitle = {
  fontWeight: "700",
  mb: 1,
};

export default RstHistoryCard;
